import React from "react";
import { useTranslation } from "react-i18next";
import Label from "components/label";
import styles from "./booking_date.module.css"

const CHECKIN_DATE = "checkin";

export default function BookingDate({ date, type=CHECKIN_DATE}) {
  const { t } = useTranslation();

  const dateConfig = {
    checkin: {
      label: t("payment_page:booking_summary:check_in"),
      className: styles.dateFrom,
    },
    checkout: {
      label: t("payment_page:booking_summary:check_out"),
      className: styles.dateTo,

    },
  };

  const dateParams = dateConfig[type];

  if (!date) {
    return null;
  }

  return (
    <div className={styles.datesFromTo}>
    
       <div className={styles.container}>
        <Label className={styles.label}> {dateParams.label} time</Label>
        <strong> {date} </strong>
        </div> 
    
    </div>
  );
}
